'use client'

import { Loader2 } from 'lucide-react'

import { useTopics } from '@/hooks/useTopics'
import { User } from '@/payload-types'

import { TopicForm } from './TopicForm'

export const TopicStep = ({
  user,
  // setOpenDrawer,
  // openDrawer,
  onUserUpdated,
}: {
  user: User
  setOpenDrawer: (open: boolean) => void
  openDrawer: boolean
  onUserUpdated?: (updatedUser?: User) => Promise<void>
  // onUserUpdated?: () => void
}) => {
  const { topics, loading } = useTopics('bills')

  return (
    <div>
      <h2 className="p-4 text-center font-family-display text-4xl">
        What would like to hear more about?
      </h2>
      {loading ? (
        <div className="flex h-full items-center justify-center font-family-body">
          <p className="text-center">
            Loading topics <Loader2 className="mx-auto block size-8 animate-spin text-accent-5" />
          </p>
        </div>
      ) : !topics.length ? (
        <div className="flex h-full items-center justify-center">
          <p>No topics found</p>
        </div>
      ) : (
        <TopicForm topics={topics} user={user} onUserUpdated={onUserUpdated} />
      )}
    </div>
  )
}
